import { rootApi } from "@/services/api/api";
import type { GetProfileResponse, UpdateProfileRequest } from "../types";

const profileApi = rootApi.injectEndpoints({
  endpoints: (build) => ({
    getProfile: build.query<GetProfileResponse, void>({
      query: () => ({
        url: "/profile",
        method: "GET",
      }),
      providesTags: ["profile"],
    }),
    updateProfile: build.mutation<void, UpdateProfileRequest>({
      query: (data) => ({
        url: "/profile",
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["profile"],
    }),
    sendConfirmEmailCode: build.mutation<void, void>({
      query: () => ({
        url: "/profile/email/send-verification",
        method: "POST",
      }),
    }),
    confirmEmail: build.mutation<void, { code: string }>({
      query: ({ code }) => ({
        url: "/profile/email/verify",
        method: "POST",
        body: { code },
      }),
      invalidatesTags: ["profile"],
    }),
  }),
});

export const {
  useGetProfileQuery,
  useUpdateProfileMutation,
  useSendConfirmEmailCodeMutation,
  useConfirmEmailMutation,
} = profileApi;
